import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NameEntryModal from '../NameEntryModal';

class RenameEstimateButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
  }

  openModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    return (
      <div className="editEstimate">
        <button id="editEstimateButton" className="link" onClick={this.openModal}>
          Rename
        </button>
        <NameEntryModal
          modalIsOpen={this.state.modalIsOpen}
          validate={this.props.validate}
          action={this.props.renameEstimate}
          title="Rename Design name"
          verb="Save"
          defaultName={this.props.defaultName}
          closeModal={this.closeModal}
        />
      </div>
    );
  }
}

RenameEstimateButton.propTypes = {
  renameEstimate: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  defaultName: PropTypes.string.isRequired,
};

export default RenameEstimateButton;
